import React from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceOrderForm from '../../components/ServiceOrders/ServiceOrderForm';
import Toast from '../../components/Common/Toast';
import { useState } from 'react';

const CreateServiceOrder = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Orden de servicio creada exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/service-orders');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/service-orders');
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva Orden de Servicio</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear una nueva orden de servicio</p>
        </div>

        {/* Formulario */}
        <ServiceOrderForm
          isOpen={true}
          onClose={handleCancel}
          order={null}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateServiceOrder;



